//NEXT_PUBLIC_DEPICT_MERCHANT is for Client Side
//DEPICT_MERCHANT is for Server Side
export const depictMerchant =
    process.env.DEPICT_MERCHANT || process.env.NEXT_PUBLIC_DEPICT_MERCHANT || "poc"
